export const isVisibleIsMeButton = (ageMin: number, userAge: number) => {
  if (ageMin === 18) {
    return userAge >= 18 && userAge < 70;
  } else if (ageMin === 70) {
    return userAge >= 70;
  } else {
    return false;
  }
};
